











































































import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'Chem51LBProject2FSProcedure',
  components: {TableInput},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        rows1: [
          {
            chemicalName: '',
            molarMass: '',
            densityConc: '',
            equivalents: '',
            mmol: '',
            amountUsed: '',
          },
        ],
        rows2: [
          {
            chemicalName: '',
            physicalStates: '',
            mp: '',
            bp: '',
          },
        ],
        supplyList: '',
      },
      attachments: [] as File[],
      columns1: [
        {label: 'Compound Name', component: STextarea, prop: 'chemicalName', width: '24%'},
        {
          label: 'Molar Mass (g/mol)',
          component: STextarea,
          prop: 'molarMass',
          width: '14%',
        },
        {
          label: 'Density or Concentration',
          component: STextarea,
          prop: 'densityConc',
          width: '14%',
        },
        {label: 'Equivalents', component: STextarea, prop: 'equivalents', width: '10%'},
        {label: 'mmol', component: STextarea, prop: 'mmol', width: '10%'},
        {label: 'Amount Used', component: STextarea, prop: 'amountUsed', width: '10%'},
      ],
      columns2: [
        {label: 'Compound Name', component: STextarea, prop: 'chemicalName', width: '36%'},
        {
          label: 'Physical State at Room Temp',
          component: STextarea,
          prop: 'physicalStates',
          width: '28%',
        },
        {label: 'Melting point (°C)', component: STextarea, prop: 'mp', width: '18%'},
        {label: 'Boiling point (°C)', component: STextarea, prop: 'bp', width: '18%'},
      ],
    };
  },
  computed: {
    attachments(): File[] {
      return [...this.attachments];
    },
  },
  methods: {},
});
